import PropTypes from 'prop-types';

import s from './tickerBlack.module.css';

function TickerBlack({ text }) {
  return (
    <div className={s.ticker}>
      <p>
        {text} <span>{`//`}</span> {text} <span>{`//`}</span>
      </p>
      <p aria-hidden="true">
        {text} <span>{`//`}</span> {text} <span>{`//`}</span>
      </p>
    </div>
  );
}

export default TickerBlack;

TickerBlack.propTypes = {
  text: PropTypes.string.isRequired,
};
